export default __webpack_public_path__ + "static/media/EngineeringCanals_03.93918638.png";